<div
  class="card interaccion-card"
  [ngStyle]="{ 'margin-left': '0.' + nivel * 1 + 'rem' }">
  <!-- Encabezado: Actor + acciones de actualizar/eliminar -->
  <div
    class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
    (click)="toggleCollapse()"
    style="cursor: pointer">
    <div class="d-flex align-items-center">
      <input
        *ngIf="!isReadOnly"
        type="radio"
        name="selectedInteraction"
        (click)="onSeleccionar()"
        class="me-2 radio" />
      <span>{{ interaccion.actor }}</span>
      <ng-container *ngIf="interaccion.tipo === 'Llamada a equipo'">
        <span class="badge bg-info ms-2"> >> {{ interaccion.equipo }}</span>
      </ng-container>
      <ng-container *ngIf="interaccion.tipo === 'Respuesta de equipo'">
        <span class="badge bg-warning ms-2"> << {{ interaccion.equipo }}</span>
      </ng-container>
      <ng-container *ngIf="interaccion.tipo === 'Salta a'">
        <span class="badge bg-success ms-2"> | </span>
      </ng-container>
      <span class="ms-2 fw-bold" *ngIf="interaccion.interacciones.length > 0">{{
        !isExpanded ? '＋' : '－'
      }}</span>
    </div>
    <div>
      <button
        type="button"
        *ngIf="!isReadOnly"
        class="btn btn-sm btn-outline-light me-2 option-box"
        (click)="onAgregar()">
        Agregar
      </button>
      <button
        type="button"
        *ngIf="!isReadOnly"
        class="btn btn-sm btn-outline-light me-2 option-box"
        (click)="onActualizar()">
        Actualizar
      </button>
      <button
        type="button"
        *ngIf="!isReadOnly"
        class="btn btn-sm btn-outline-light option-box"
        (click)="onEliminar()">
        Eliminar
      </button>
    </div>
  </div>
  <!-- Cuerpo: Texto de la interacción -->
  <div class="card-body">
    <p class="id-box">Id: {{ interaccion.id }}</p>
    <p class="card-text">{{ interaccion.texto }}</p>
  </div>
  <!-- Pie: Renderiza de forma recursiva las interacciones internas -->
  <div
    class="card-footer footer-box"
    *ngIf="isExpanded && interaccion.interacciones.length > 0">
    <ng-container *ngFor="let item of interaccion.interacciones">
      <app-interaccion
        [interaccion]="item"
        [nivel]="nivel + 1"
        [isReadOnly]="isReadOnly"
        (seleccionado)="seleccionado.emit($event)"
        (agregar)="agregar.emit($event)"
        (actualizar)="actualizar.emit($event)"
        (eliminar)="eliminar.emit($event)">
      </app-interaccion>
    </ng-container>
  </div>
</div>
